import { OrganizationRoutes } from "./organization.routes";
import { OrganizationEditModel } from "./organization-edit.model";

angular.module("thor.organization", [])
    .service("organizationEditModel", OrganizationEditModel)
    .config(OrganizationRoutes);
